import cleanString from './cleanString'

export const createArticleSchema = (article, url, isNews) => {
  if (!article) {
    return null
  }

  return `{
  "@context": "https://schema.org",
  "@type": "${isNews ? "NewsArticle" : "Article"}",
  "headline": "${cleanString(article.articleTitle)}",
  "image": "${article.posterImage?.url}",
  "url": "${url}",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "${url}"
  },
  "datePublished": "${article.createdAt}",
  "dateModified": "${article?.updatedAt || article.createdAt}",
  "author": {
    "@type": "Person",
    "name": "${article.articleAuthor || 'Heliguy'}"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Colena Ltd / heliguy™",
    "logo": {
      "@type": "ImageObject",
      "url": "${process.env.GATSBY_HELIGUY_DOMAIN}/favicon.svg"
    }
  }
}`
}
